import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AddMovementServiceButtonProps {
  langBase: string;
  ownersMatter?: boolean;
  proposedAgency?: boolean;
}

const AddMovementServiceButton = ({
  langBase,
  ownersMatter,
  proposedAgency,
}: AddMovementServiceButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userActionPermissions } = useAuthStore();

  return checkPermission(userActionPermissions, "canRequestMovementService") &&
    !ownersMatter &&
    !proposedAgency ? (
    <Button
      type="button"
      variant="contained"
      color="primary"
      testId={`${langBase}-create-button`}
      label={
        <span className="text-sm font-medium flex items-center gap-2">
          <AddCircleOutlineIcon fontSize="small" />
          {t(`${langBase}.add-service`)}
        </span>
      }
      sx={{
        textTransform: "none",
        height: "40px",
        minHeight: "40px",
      }}
      onClick={() => navigate(`${paths.vesselCall.addMovementService}`)}
    />
  ) : null;
};
export default AddMovementServiceButton;
